import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title-big t-blue uppercase text-center mb-5" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "form-wrapper mt-4" }
const _hoisted_4 = { class: "uppercase text-raleway-13" }
const _hoisted_5 = { class: "uppercase text-raleway-13" }
const _hoisted_6 = { class: "d-flex a-i-center j-content-s-be" }
const _hoisted_7 = { class: "uppercase text-raleway-13" }
const _hoisted_8 = {
  class: "btn btn-default login w-100",
  type: "submit"
}

import { CallbackComponentValidation } from "../../utils/validation/callbackValidation/callbackValidation";
import { IStore } from "../../../../chat_brave_developers_front/src/redux/type";
import { UserTypeOperation } from "../../store/modules/User/type";
import { CallbackType } from "../../store/modules/Callback/type";
import { IUseFetchDetailError } from "@/hook/fetch/interface";
import { Field, useForm } from "vee-validate";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useFetch } from "@/hook/fetch/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactUseView',
  setup(__props) {

const store = useStore<IStore>();

const initialValues = ref<CallbackType>(
  store.getters.getInitialValuesCallbackModuleOperation
);

const userData = ref(
  computed<UserTypeOperation>(() => store.getters.getUserDataCustomer)
);

const { values, errors, validate, resetForm } = useForm<CallbackType>({
  initialValues: {
    ...initialValues?.value,
    ...userData?.value,
  },
  validationSchema: CallbackComponentValidation,
});

const callback = () => {
  validate().then(async () => {
    let data: any = {};

    data.email = values.email;
    data.subject = values.first_name;
    data.message = values.message;

    const { isError } = await useFetch<null, IUseFetchDetailError>(
      process.env.VUE_APP_SERVER + "api/contact_us/",
      "POST",
      !!store.getters.accessTokenGet,
      data
    );

    if (!isError.value)
      store.commit("setPopupAccount", {
        open: true,
        message: [
          {
            Contact_us: { Response: ["Successfully"] },
          },
        ],
      });
    else
      store.commit("setPopupAccount", {
        open: true,
        message: [
          {
            Contact_us: { Response: ["Server Error"] },
          },
        ],
      });
    resetForm();
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$tc("Contact us")), 1),
    _createElementVNode("form", {
      class: "form pt-5",
      onSubmit: _withModifiers(callback, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["input-wrapper", { 'error-input': _unref(errors)?.first_name }])
        }, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$tc("name")), 1),
          _createVNode(_unref(Field), {
            maxlength: "55",
            type: "text",
            name: 'first_name',
            value: _unref(values).first_name,
            class: "input",
            autocapitalize: "off"
          }, null, 8, ["value"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["input-wrapper", { 'error-input': _unref(errors)?.email }])
        }, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$tc("Email address")), 1),
          _createVNode(_unref(Field), {
            maxlength: "55",
            type: "text",
            name: 'email',
            value: _unref(values).email,
            class: "input",
            autocapitalize: "off"
          }, null, 8, ["value"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["mb-5", { 'error-input mini': _unref(errors)?.message }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$tc("message")), 1)
          ]),
          _createVNode(_unref(Field), {
            value: _unref(values)?.message,
            name: "message"
          }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("textarea", _mergeProps({
                tabindex: 20,
                maxlength: "535",
                class: "select-textarea input"
              }, field, {
                name: 'message',
                placeholder: ''
              }), null, 16)
            ]),
            _: 1
          }, 8, ["value"])
        ], 2)
      ]),
      _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.$tc("submit")), 1)
    ], 40, _hoisted_2)
  ], 64))
}
}

})